import axios from '../../axios'

/**
 * 1.1.1 获取项目测试标准
 * @param examinItemId  项目id
 * @returns {Promise | Promise<unknown>}
 */
export const list = examinItemId => {
  return axios({
    url: '/clubExamines/examinItemStandard/list/' + examinItemId,
    method: 'GET'
  })
}

/**
 * 1.1.2 查询年级对应的体测项目
 * @param gradeId
 * @returns {Promise | Promise<unknown>}
 */
export const findByGrade = gradeId => {
  return axios({
    url: 'clubExamines/examinItemStandard/findByGrade/' + gradeId,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examines/examinStandard.js